import Helper from "../../Helper";
import { Area } from "../../models/Area";
import { MapObject } from "../../models/MapObject";
import { WaypointDirection } from "../../models/WaypointDirection";
import { plotFetch } from "../Helper/ApiRequest";

export function getProjectAreas(
    team_subdomain: string,
    project_token: string,
    timezone: string,
    archived: boolean = false
): Promise<Area[]> {
    const url = `${Helper.baseUrlAltSubdomain(team_subdomain || "projects")}/projects/${project_token}/areas?archived=${archived}`;

    return plotFetch(url, { method: "GET" }, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .then((response) => {
            return response.map((area: any) => Area.fromApiObject(area, timezone));
        })
        .catch((error) => {
            return [];
        });
}

export function getAreaAttachments(team_subdomain: string, project_token: string, area_id: number): Promise<any[]> {
    const url = `${Helper.baseUrlAltSubdomain(team_subdomain || "projects")}/projects/${project_token}/areas/${area_id}/areas_attachments`;

    return plotFetch(url, { method: "GET" }, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .catch((error) => {
            return [];
        });
}

export function deleteArea(team_subdomain: string, project_token: string, area: Area): Promise<boolean> {
    return plotFetch(
        `${Helper.baseUrlAltSubdomain(team_subdomain)}/projects/${project_token}/areas/${area.id}`,
        { method: "DELETE" },
        true
    )
        .then((response) => {
            if (response.ok) {
                return true;
            }
            throw new Error("Network error.");
        })
        .catch(() => {
            return false;
        });
}

export function createArea(
    team_subdomain: string,
    project_token: string,
    area: Area,
    map_object: MapObject,
    tagged_teams: number[],
    timezone: string
): Promise<Area | null> {
    return plotFetch(
        `${Helper.baseUrlAltSubdomain(team_subdomain)}/projects/${project_token}/areas`,
        {
            method: "POST",
            body: JSON.stringify({
                area: area.toApiObject(),
                map_object: map_object.toApiObject(),
                tagged_teams: tagged_teams,
            }),
        },
        true
    )
        .then(async (data) => {
            const jsonData = await data.json();
            if (!data.ok) {
                const errorMessage = jsonData.error || data.statusText;
                throw new Error(errorMessage);
            }
            return jsonData;
        })
        .then((data) => {
            return Area.fromApiObject(data, timezone);
        })
        .catch(() => {
            return null;
        });
}

export function updateArea(
    team_subdomain: string,
    project_token: string,
    area: Area,
    tagged_teams: number[],
    timezone: string
): Promise<Area | null> {
    return plotFetch(
        `${Helper.baseUrlAltSubdomain(team_subdomain)}/projects/${project_token}/areas/${area.id}`,
        {
            method: "PUT",
            body: JSON.stringify({ area: area.toApiObject(), tagged_teams: tagged_teams }),
        },
        true
    )
        .then((data) => {
            if (data.ok) {
                return data.json();
            }
            throw new Error("Network error.");
        })
        .then((data) => {
            return Area.fromApiObject(data, timezone);
        })
        .catch(() => {
            return null;
        });
}
export const updateWaypointDirection = (
    team_subdomain: string,
    project_token: string,
    waypointDirection: WaypointDirection
): Promise<WaypointDirection | null> => {
    return plotFetch(
        `${Helper.baseUrlAltSubdomain(team_subdomain)}/projects/${project_token}/waypoint_directions/${waypointDirection.id}`,
        {
            method: "PUT",
            body: JSON.stringify({ waypoint_direction: waypointDirection.toApiObject() }),
        },
        true
    )
        .then((data) => {
            if (data.ok) {
                return data.json();
            }
            throw new Error("Network error.");
        })
        .then((data) => {
            return WaypointDirection.fromApiObject(data, Intl.DateTimeFormat().resolvedOptions().timeZone);
        })
        .catch(() => {
            return null;
        });
};
